import { Link } from 'react-router-dom';
import { hotArticles } from '@/mocks/articles';

const tagStyles: Record<string, string> = {
  '热': 'bg-primary-500/20 text-primary-400 border border-primary-500/30',
  '爆': 'bg-accent-500/20 text-accent-400 border border-accent-500/30',
  '新': 'bg-foreground-300/10 text-foreground-400 border border-foreground-300/20',
};

const tags = ['热', '爆', '新'] as const;

export default function HotGossipSection() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-20">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="mb-10 md:mb-14">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-black text-foreground-50">
            今日大瓜
          </h2>
          <p className="text-lg md:text-xl text-foreground-400 font-heading mt-1">
            实时更新
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {hotArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group block rounded-2xl border border-secondary-800/50 bg-background-200 overflow-hidden hover:border-secondary-600/60 transition-all duration-300"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  title={`爆料吃瓜 - ${article.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-100 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span
                    className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${
                      tagStyles[tags[index]] || tagStyles['新']
                    }`}
                  >
                    {tags[index]}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <span className="text-xs text-accent-400 font-medium">
                  {article.category}
                </span>
                <h3 className="mt-2 text-base md:text-lg font-bold text-foreground-50 leading-snug group-hover:text-primary-400 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <div className="mt-4 flex items-center justify-between text-xs text-foreground-500">
                  <span>{article.publishDate}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.viewCount.toLocaleString()}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}